import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router";

import { AffixRequestApi, EPlatform, ERequestState, KennelImportRequestDto, RequestDto } from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { DrupalKennelImportRequestForm } from "./DrupalKennelImportRequestForm";

export interface IDrupalKennelImportRequestPageProps {}

export const DrupalKennelImportRequestPage: React.FunctionComponent<IDrupalKennelImportRequestPageProps> = () => {
  const { id } = useParams<{ id: string }>();

  const kennelImportRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(AffixRequestApi);
  // TODO-CRR : saving is used, but not saveItem???
  const { data, loading, saving } = useCrudApi<KennelImportRequestDto>(
    React.useMemo(
      () => ({
        getApiFn: (apiId = kennelImportRequestId) =>
          apiId > 0
            ? api.getImportKennelRequest(apiId)
            : new KennelImportRequestDto({
                request: new RequestDto({
                  requestDate: new Date(),
                  status: ERequestState.REQUESTED,
                  platform: EPlatform.PORTAL,
                }),
              }).toJSON(),
        saveApiFn: (d: KennelImportRequestDto) =>
          api.saveKennelImportRequest(KennelImportRequestDto.fromJS({ ...d, isPortal: true })),
        onSavedRoute: (d) =>
          d.request.status === ERequestState.BILLED
            ? `${EDrupalRoutes.kennelImportRequest}/${d.kennelImportRequestId}`
            : EDrupalRoutes.requestList,
        deleteApiFn: () => {},
      }),
      [api, kennelImportRequestId]
    ),
    [kennelImportRequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet title={`${t(ETLCodes.Payment)}: ${t(ETLCodes.ImportKennelRequest)}`}>
        <div>
          {saving ? (
            <Spinner />
          ) : (
            <DrupalRequestResume
              requestForm={
                <DrupalKennelImportRequestForm
                  kennelImportRequestId={kennelImportRequestId}
                  initialdata={data}
                  loading={saving}
                />
              }
              requestDto={data?.request}
              bill={null}
            />
          )}
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
